module.exports = __webpack_public_path__ + "img/Orion_edit.e9eabf28.svg";